// src/api/customer.js
import { customerApi } from "../utils/apiConfig";

export const createTicket = (data, token) =>
  customerApi.post("/createTicket", data, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getTickets = (token) =>
  customerApi.get("/getTickets", {
    headers: { Authorization: `Bearer ${token}` },
  });


export const getDepartmans = (token) =>
  customerApi.get("/getDepartmans", {
    headers: { Authorization: `Bearer ${token}` },
  });
